var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","bottom":"0","width":"calc(100vw)","z-index":"9999"},attrs:{"id":"kt_copyright_footer"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._v(" Copyright © 2022 Total Biometric Solutions LLC. All rights reserved. ")])])])
}]

export { render, staticRenderFns }